<div class="content" *ngIf="!isEmpty()">
  <div class="level" *ngFor="let level of content.levels">
    <div class="item" *ngIf="level.skus && level.skus.length > 0; else noSkus">
      
      <div class="level-name">
        <span class="order" *ngIf="level.type == MapTooltipLevelType.REGULAR">{{level.order}} - </span>
        <span class="name">{{level.name}}</span>
        <span class="pallet-qty"> ({{level.palletQty}} pallets)</span>
      </div>

      <div *ngFor="let sku of level.skus" >
        <div *ngIf="sku.sku" class="sku">{{sku.sku}} - quantidade: {{sku.quantity}}</div>
      </div>
    </div>
    <ng-template #noSkus>
      <div class="item" *ngIf="level.type == MapTooltipLevelType.REGULAR">
        <div class="level-name empty-level">
          <span class="order">{{level.order}} - </span>
          <span class="name">{{level.name}}</span>
          (vazio)
        </div>
      </div>
    </ng-template>
  </div>
</div>
<div class="empty" *ngIf="isEmpty()">
  <div class="level">
    <div class="item">
      <div class="level-name">Não existem produtos aqui.</div>
    </div>
  </div>
</div> 